import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import "./CSS/HotelDetails.css";

const HOTEL_DETAIL_API = "https://api.hotel.namantechnolab.com/api/hotel/DetailSearch";
const HOTEL_REVIEW_API = "https://api.hotel.namantechnolab.com/api/hotel/Review";

export default function HotelDetails() {
  const { tripId } = useParams();
  const [details, setDetails] = useState(null);
  const [hotelBasic, setHotelBasic] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showFullDesc, setShowFullDesc] = useState(false);   // <-- yahan
  const [activeTab, setActiveTab] = useState("Rooms");
  const [activeImage, setActiveImage] = useState(0);
  const [selectedRoomIdx, setSelectedRoomIdx] = useState(0);

  // Book Now -> Review API state
  const [bookingLoading, setBookingLoading] = useState(false);
  const [bookingError, setBookingError] = useState(null);

  useEffect(() => {
    const storedHotel = sessionStorage.getItem("selectedHotel");
    if (storedHotel) {
      try {
        setHotelBasic(JSON.parse(storedHotel));
      } catch (err) {
        console.error("Could not parse selected hotel", err);
      }
    }

    if (tripId) {
      fetchHotelDetails(tripId);
    } else {
      setLoading(false);
      setError("No TripId found in URL.");
    }
  }, [tripId]);

  const fetchHotelDetails = async (id) => {
    setLoading(true);
    setError(null);

    const payload = { id: id };

    console.log("Hotel detail URL:", HOTEL_DETAIL_API);
    console.log("Hotel detail request payload:", payload);

    try {
      const res = await fetch(HOTEL_DETAIL_API, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });
      if (!res.ok) {
        throw new Error(`Request failed with status ${res.status}`);
      }

      const data = await res.json();
      console.log("Hotel detail response:", data);
      console.log("Description:", typeof data.Description, data.Description);
console.log("Keys:", Object.keys(data));
      setDetails(data);

      try {
        sessionStorage.setItem("hotelDetailsResponse", JSON.stringify(data));
      } catch (err) {
        console.error("Could not persist hotel detail response", err);
      }
    } catch (err) {
      console.error("Hotel detail request failed:", err);
      setError(err.message || "Something went wrong while fetching hotel details.");
    } finally {
      setLoading(false);
    }
  };

  // ---------- Book Now -> Review API ----------
  const handleBookNow = async (room) => {
    if (!room) {
      setBookingError("Please select a room before booking.");
      return;
    }

    setBookingLoading(true);
    setBookingError(null);

    let searchResponse = null;
    let selectedHotel = null;

    try {
      searchResponse = JSON.parse(sessionStorage.getItem("hotelSearchResponse") || "null");
    } catch (err) {
      console.error("Could not parse hotel search response", err);
    }

    try {
      selectedHotel = JSON.parse(sessionStorage.getItem("selectedHotel") || "null");
    } catch (err) {
      console.error("Could not parse selected hotel", err);
    }

    if (!searchResponse || !selectedHotel) {
      setBookingError("Hotel search data not found. Please go back and search again.");
      setBookingLoading(false);
      return;
    }

    const payload = {
      HotelId: String(selectedHotel.TripId || selectedHotel.HotelId || tripId || ""),
      optionId: String(room?.optionsid || room?.optionsId || room?.BookHash || ""),
      HotelSearchres: searchResponse,
    };

    console.log("Hotel review URL:", HOTEL_REVIEW_API);
    console.log("Hotel review request payload:", payload);

    try {
      const res = await fetch(HOTEL_REVIEW_API, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      if (!res.ok) {
        const errBody = await res.text();
        throw new Error(`Request failed with status ${res.status}: ${errBody}`);
      }

      const data = await res.json();
      console.log("Hotel review response:", data);

      try {
        sessionStorage.setItem("hotelReviewResponse", JSON.stringify(data));
        sessionStorage.setItem("selectedRoomOption", JSON.stringify(room));
      } catch (err) {
        console.error("Could not persist hotel review data", err);
      }

      // Review / booking confirmation page par navigate karo
      window.location.href = "/hotel-review";
    } catch (err) {
      console.error("Hotel review request failed:", err);
      setBookingError(err.message || "Something went wrong while fetching room review.");
    } finally {
      setBookingLoading(false);
    }
  };

  // ---------- Helpers mapped to actual API field names ----------

  const pick = (...vals) => vals.find((v) => v !== undefined && v !== null && v !== "");

  const hotelName = pick(hotelBasic?.HotelName, details?.hotelname, "Hotel Name");

  const starRating = Number(pick(hotelBasic?.StarRating, details?.HotelRating, 0));

  const address = pick(details?.HotelAddress, hotelBasic?.Address, "");

  const cityLine = [address, details?.CityName, details?.StateName, details?.CountryName]
    .filter(Boolean)
    .join(", ");

  const rating = starRating || 5.0;

  const reviewCount = pick(hotelBasic?.ReviewCount, details?.ReviewCount, 1);

  const images = pick(details?.Images, hotelBasic?.Images, []) || [];

  const mainImage = images[activeImage] || null;

  const mapUrl =
    details?.Latitude && details?.Longititude
      ? `https://www.google.com/maps?q=${details.Latitude},${details.Longititude}`
      : null;

  const rooms = pick(details?.HotelRooms, []) || [];

  const selectedRoom = rooms[selectedRoomIdx] || rooms[0] || null;

  const getRoomName = (r) => pick(r?.RoomType, r?.RoomCategory, "Room");

  const getRoomOccupancy = (r) => pick(r?.Adults, 1);

  // API gives only one totalPrice (no separate MRP/strike price)
  const getOfferedPrice = (r) => Number(pick(r?.totalPrice, 0));

  const getMealBasis = (r) => pick(r?.Mealbasis, "Room Only");

  const getRoomImages = (r) => pick(r?.RommImages, []) || [];

  const policyNote = pick(
    details?.HotelPolicy?.length ? details.HotelPolicy.join(" ") : null,
    "Primary guest should be at least 18 years of age. Please carry a valid government-issued ID proof at check-in."
  );

  const facilities = pick(details?.HotelFacility, []) || [];
const description = typeof details?.Description === "string" ? details.Description : "";
const reviewScore = details?.ReviewScore ? (Number(details.ReviewScore) / 10).toFixed(1) : null;
const ratingValue = reviewScore || (starRating ? starRating.toFixed(1) : "4.0");
const ratingLabel =
  Number(ratingValue) >= 4.5 || Number(ratingValue) >= 9 ? "Excellent"
  : Number(ratingValue) >= 3.5 || Number(ratingValue) >= 7.5 ? "Very Good" : "Good";
const reviewsTotal = pick(details?.ReviewCount, hotelBasic?.ReviewCount, 0);

const sideImages = [1, 2].map((o) => images[(activeImage + o) % (images.length || 1)]);
const roomBenefits = selectedRoom
  ? [
      getMealBasis(selectedRoom),
      selectedRoom.IsRefundable ? "Free Cancellation available" : null,
      ...(selectedRoom.RoomFacilities || []).slice(0, 3),
    ].filter(Boolean)
  : [];
const shortDesc = description.length > 230 ? description.slice(0, 230).trim() + "…" : description;

    const formatINR = (n) => "₹" + Number(n || 0).toLocaleString("en-IN", { maximumFractionDigits: 0 });

  const tabs = ["Rooms", "Overview", "Amenities", "Location", "Booking Policy", "Guest Rating"];
console.log("Description type:", typeof details?.Description, details?.Description);
  if (loading) {
    return (
      <div className="centerScreen">
        <div className="spinner" />
        <p style={{ marginTop: 12, color: "#6b7280" }}>Loading hotel details…</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="centerScreen">
        <p style={{ color: "#dc2626", fontWeight: 600 }}>{error}</p>
      </div>
    );
  }

  return (
    <div className="page">
      {/* ---------- Header card ---------- */}
  {/* ---------- Header card ---------- */}
<div className="card headerCard">
  <div className="headerTop">
    <div>
      <div className="titleRow">
        <h1 className="hotelName">{hotelName}</h1>
        <span className="stars">
          {"★".repeat(Math.max(0, Math.min(5, starRating || 0)))}
          <span className="starsOff">{"★".repeat(5 - Math.max(0, Math.min(5, starRating || 0)))}</span>
        </span>
        <span className="badge">{pick(details?.PropertyType, "Hotel")}</span>
      </div>
      <div className="addressRow">
        <span>📍</span>
        <span>{cityLine || "Address not available"}</span>
        {mapUrl && (
          <a href={mapUrl} target="_blank" rel="noreferrer" className="mapLink">View on map</a>
        )}
      </div>
    </div>
    <div className="ratingBox">
      <div>
        <div className="ratingLabel">{ratingLabel}</div>
        <div className="ratingReviews">{reviewsTotal} reviews</div>
      </div>
      <div className="ratingPill">{ratingValue}</div>
    </div>
  </div>

  <div className="galleryRow">
    {/* Left: gallery */}
    <div className="galleryGrid">
      <div className="mainImageWrap">
        {mainImage ? (
          <img src={mainImage} alt={hotelName} className="mainImage" />
        ) : (
          <div className="imagePlaceholder">No image available</div>
        )}
        {images.length > 1 && (
          <>
            <button className="navBtn navLeft"
              onClick={() => setActiveImage((i) => (i - 1 + images.length) % images.length)}>‹</button>
            <button className="navBtn navRight"
              onClick={() => setActiveImage((i) => (i + 1) % images.length)}>›</button>
            <div className="photoBtn">{images.length} Property Photos →</div>
          </>
        )}
      </div>
      <div className="thumbCol">
        {sideImages.map((src, i) => (
          <div key={i} className="thumb"
            onClick={() => setActiveImage((activeImage + i + 1) % (images.length || 1))}>
            {src ? <img src={src} alt="" /> : <div className="thumbPlaceholder" />}
          </div>
        ))}
      </div>
    </div>

    {/* Right: booking card */}
    <div className="bookingCard">
      {selectedRoom ? (
        <>
          <div className="roomName">{getRoomName(selectedRoom)}</div>
          <div className="roomMeta">
            Fits {getRoomOccupancy(selectedRoom)} Adult{Number(getRoomOccupancy(selectedRoom)) > 1 ? "s" : ""}
          </div>

          <ul className="benefitList">
            {roomBenefits.map((b, i) => (
              <li key={i}>✓ {b}</li>
            ))}
          </ul>

          <div className="priceBlock">
            <div className="perNight">Total price:</div>
            <div className="offerPrice">{formatINR(getOfferedPrice(selectedRoom))}</div>
          </div>

          {bookingError && <div className="errorText">{bookingError}</div>}

          <button className="btnBook" onClick={() => handleBookNow(selectedRoom)}
            disabled={bookingLoading}>
            {bookingLoading ? "CHECKING AVAILABILITY..." : "BOOK THIS NOW"}
          </button>

          {rooms.length > 1 && (
            <div className="moreOptions">
              <div>
                <div className="moreTitle">More options available with</div>
                <div className="moreSub">Different meal plans &amp; cancellation</div>
              </div>
              <button className="btnViewAll" onClick={() => setActiveTab("Rooms")}>
                VIEW ALL ({rooms.length - 1})
              </button>
            </div>
          )}
        </>
      ) : (
        <div className="noRooms">Room details not available.</div>
      )}
    </div>
  </div>

  {/* About property */}
  {description && (
    <div className="aboutBox">
      <h3 className="aboutTitle">About Property</h3>
      <p className="aboutText">
        {showFullDesc ? description : shortDesc}{" "}
        {description.length > 230 && (
          <button className="linkBtn" onClick={() => setShowFullDesc((s) => !s)}>
            {showFullDesc ? "Less" : "More"}
          </button>
        )}
      </p>
    </div>
  )}
</div>

      {/* ---------- Tabs ---------- */}
      <div className="card tabCard">
        {tabs.map((t) => (
          <button
            key={t}
            className={`tabBtn ${activeTab === t ? "active" : ""}`}
            onClick={() => setActiveTab(t)}
          >
            {t}
          </button>
        ))}
      </div>

      {/* ---------- Policy note ---------- */}
      <div className="card noticeCard">
        <span className="noticeIcon">ⓘ</span>
        <span>
          <strong>Please Note:</strong> {policyNote}
        </span>
      </div>

{/* ---------- Overview tab ---------- */}
{activeTab === "Overview" && (
  <div className="card">
    {description ? (
      description
        .split(/\n\s*\n/)
        .filter((p) => p.trim())
        .map((para, i) => (
          <p
            key={i}
            style={{ color: "#374151", fontSize: 14, lineHeight: 1.6, marginBottom: 12 }}
          >
            {para.trim()}
          </p>
        ))
    ) : (
      <p style={{ color: "#6b7280" }}>No description available.</p>
    )}
  </div>
)}

      {/* ---------- Amenities tab ---------- */}
      {activeTab === "Amenities" && (
        <div className="card">
          <div className="amenityTags" style={{ flexWrap: "wrap" }}>
            {facilities.map((f, i) => (
              <span className="amenityTag" key={i}>
                ✓ {f}
              </span>
            ))}
          </div>
        </div>
      )}

      {/* ---------- Room table ---------- */}
      {activeTab === "Rooms" && (
        <div className="card tableCard">
          <div className="tableHeader">
            <div>Room Type</div>
            <div>Benefits</div>
            <div>Per Night Price</div>
            <div></div>
          </div>

          {bookingError && (
            <div style={{ color: "#dc2626", fontSize: 13, padding: "8px 4px" }}>
              {bookingError}
            </div>
          )}

          {rooms.length ? (
            rooms.map((r, idx) => (
<div className="tableRow" key={r.optionsId || r.RoomId || idx}>
                  <div className="roomCol">
                  {getRoomImages(r)[0] && (
                    <img src={getRoomImages(r)[0]} alt={getRoomName(r)} />
                  )}
                  <div className="roomColName">{getRoomName(r)}</div>
                </div>

                <div className="benefitsCol">
                  <div>✓ {getMealBasis(r)}</div>
                  <div>✓ {r.Adults} Adult{Number(r.Adults) > 1 ? "s" : ""}</div>
                  {r.SmokingAllowed === false && <div>✓ Non-Smoking</div>}
                </div>

                <div className="priceCol">
                  <div className="offerPrice small">{formatINR(getOfferedPrice(r))}</div>
                  <div className="perNight small">Total price</div>
                </div>

                <div className="actionCol">
                  <button
                    className="btnPrimary small"
                    onClick={() => {
                      setSelectedRoomIdx(idx);
                      handleBookNow(r);
                    }}
                    disabled={bookingLoading}
                  >
                    {bookingLoading ? "Checking..." : "Book Now"}
                  </button>
                </div>
              </div>
            ))
          ) : (
            <div className="noRoomsRow">No room options available for this hotel.</div>
          )}
        </div>
      )}
    </div>
  );
}